import {ReactComponent as CityIcon} from '#/components/icons/ico-city.svg';
import {ReactComponent as DistrictIcon} from '#/components/icons/ico-district.svg';
import {HomeIcon} from '@heroicons/react/24/outline';
import {UnlistedLand} from '@shareland/shareland-common';
import {FunctionComponent} from 'react';

const LandIcon: FunctionComponent<{
  land: UnlistedLand;
}> = ({land}) => {
  const className = 'stroke-gray-400 fill-gray-400';

  return land.type === 'NEIGHBORHOOD' ? (
    <HomeIcon className={'w-4 h-4 stroke-gray-400 fill-transparent'} />
  ) : land.type === 'CITY' ? (
    <CityIcon className={className} />
  ) : (
    <DistrictIcon className={className} />
  );
};

export default LandIcon;
